import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { BuildingType } from "@/api/locations";

export function BuildingTypeHandbook(props: AutocompleteProps<BuildingType>) {
  const items = useAppSelector((state) => state.handbooks.buildingType);

  return (
    <Autocomplete
      defaultItems={items}
      label="Класс здания"
      placeholder="Выберите класс здания"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={String(item.name)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}
